const ViewMode = {
  evolution: 'evolution',
  list: 'list',
  tree: 'tree',
  matrix: 'matrix'
}
export default ViewMode
